import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVm = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_112455_42639)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M34.48 21.48C34.24 21.15 33.97 20.84 33.68 20.56L33.99 20.54L34.16 20.53C34.42 20.49 34.65 20.35 34.82 20.14C34.98 19.93 35.06 19.67 35.04 19.4C35.02 19.13 34.91 18.88 34.73 18.7C34.54 18.51 34.29 18.4 34.05 18.4H34.02L30.96 18.61C30.69 18.63 30.42 18.76 30.25 18.98C30.07 19.19 29.98 19.47 30 19.75L30.2 22.97C30.24 23.23 30.37 23.47 30.57 23.64C30.78 23.81 31.03 23.9 31.29 23.88C31.55 23.86 31.8 23.75 31.98 23.55C32.13 23.39 32.22 23.19 32.25 22.97H32.27L32.22 22.09C32.44 22.31 32.65 22.55 32.84 22.8C33.23 23.3 33.46 23.92 33.48 24.57C33.48 25.36 33.11 26.14 32.37 26.9C31.63 27.66 30.56 28.37 29.2 28.99C26.17 30.37 22.12 31.13 17.78 31.13C13.44 31.13 9.39001 30.37 6.36001 28.99C5.00001 28.37 3.93001 27.66 3.19001 26.9C2.45001 26.14 2.08001 25.36 2.08001 24.57C2.10001 23.91 2.33001 23.27 2.74001 22.77C3.37001 21.98 4.14001 21.33 5.01001 20.84C5.13001 20.77 5.23001 20.67 5.31001 20.56C5.39001 20.45 5.45001 20.32 5.49001 20.19C5.53001 20.06 5.54001 19.92 5.52001 19.78C5.50001 19.64 5.46001 19.51 5.40001 19.39C5.33001 19.27 5.25001 19.16 5.14001 19.07C5.03001 18.98 4.91001 18.92 4.78001 18.88C4.65001 18.84 4.51001 18.83 4.37001 18.85C4.23001 18.87 4.11001 18.91 3.99001 18.98C2.88001 19.6 1.92001 20.43 1.12001 21.45C0.43001 22.32 0.0400098 23.43 0.0100098 24.57C0.0100098 27.06 1.97001 29.33 5.53001 30.95C8.82001 32.45 13.18 33.28 17.78 33.28C22.38 33.28 26.73 32.45 30.03 30.95C33.59 29.33 35.55 27.06 35.55 24.56C35.53 23.45 35.15 22.36 34.48 21.5V21.48Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M8.30989 21.78L16.7399 26.87C17.0999 27.08 17.5299 27.2 17.9199 27.2C18.3099 27.2 18.7399 27.08 19.1099 26.87L27.5299 21.79C28.2599 21.35 28.7099 20.54 28.7099 19.67V9.53C28.7099 8.62 28.2599 7.81 27.5299 7.41L19.1099 2.33C18.7499 2.12 18.3199 2 17.9299 2C17.5399 2 17.1099 2.12 16.7399 2.33L8.31989 7.41C7.58989 7.85 7.13989 8.66 7.13989 9.53V19.66C7.13989 20.53 7.58989 21.34 8.31989 21.78H8.30989ZM11.1099 8.89L17.9199 4.8L24.7599 8.89L17.9199 13.01L11.1099 8.89ZM19.2499 23.61V15.39L26.0399 11.31V19.53L19.2499 23.61ZM9.79989 19.5V11.29L16.5899 15.4V23.61L9.79989 19.5Z",
				fill: "currentColor"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_112455_42639",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 35.55,
				height: 31.27,
				fill: "white",
				transform: "translate(0 2)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVm);
export { ForwardRef as ReactComponent };
